{
  "ts": 1745571263,
  "tsCommit": 1745571232,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "3564c6d",
  "ver": "20250425_0854_WebSignup_prod_3564c6d",
  "env": "production"
}
